export default {
  description: 'The top-level vConnect namespace',
  usage: ['v → v'],
  example: {
    description: 'Establish a top-level namespace',
    code: 'let v = VConnect(viserver, options)'
  }
}



// WEBPACK FOOTER //
// ./src/data/api/accessing_vconnect/v.js